import { CanActivateFn, Router } from '@angular/router'
import { AppStore } from '../app.store'
import { inject } from '@angular/core'

export const integratedAccountsGuard: CanActivateFn = (route, state) => {
    const router = inject(Router)
    const preferredAccountsSystemId = inject(AppStore).me()?.preferredAccountsSystemId
    const loggedIn = inject(AppStore).me()?.loggedIntoAccounts

    // if it's not surefire (0) i.e Xero, Quickbooks etc
    if (loggedIn && preferredAccountsSystemId && preferredAccountsSystemId > 0) {
        return true
    }

    router.navigateByUrl('/accounts-integrations/selector')
    return false
}
